export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji.vue?vue&type=template&id=5a659e94&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/emoji.vue?vue&type=template&id=5a659e94&scoped=true&
// module id = null
// module chunks = 